import { render } from "./InputForm.vue?vue&type=template&id=719192a2&scoped=true"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"

import "./InputForm.vue?vue&type=style&index=0&id=719192a2&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719192a2"]])

export default __exports__